module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_tuggen-57539b75c5e3a5730a6e5c2f38aeafa9.png";